import type { TheaterId } from '@fleetduel/shared'

/**
 * 2D theater palette overrides (ART_GUIDE_v3 §2 — 2D fallback).
 * `waterTint` is layered over the base v1 water tile to shift the
 * ocean toward the theater's palette without new tile assets.
 */
export interface TheaterPalette2D {
  /** rgba overlay above the water tile, or undefined for the classic look */
  waterTint?: string
}

export const THEATER_PALETTES_2D: Record<TheaterId, TheaterPalette2D> = {
  classic: {},
  // Hormuz: warm sediment water (ocean-mid #4A3228)
  hormuz: { waterTint: 'rgba(74, 50, 40, 0.45)' },
  // GIUK: cold North Atlantic steel
  giuk: { waterTint: 'rgba(141, 169, 196, 0.20)' },
  // South China Sea: shallow tropical jade
  'south-china-sea': { waterTint: 'rgba(61, 220, 151, 0.14)' },
}
